/* SCANSHOP – Guides blog behaviour: TOC, active step, lazy YouTube, hub search, type chips, feedback, mobile product bar. */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function slug(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/ł/g, 'l').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
  }
  function headerOffset() {
    var b = 0;
    $$('header, header > *, sticky-header, [class*="header"]').forEach(function (el) {
      var s = getComputedStyle(el);
      if (s.position !== 'fixed' && s.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top <= 2 && r.bottom > b && r.height < window.innerHeight / 2) b = r.bottom;
    });
    return b;
  }
  function track(name, params) {
    try {
      if (window.gtag) window.gtag('event', name, params);
      else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
    } catch (e) {}
  }

  /* ---------- article: TOC + active heading ---------- */
  function initToc() {
    var body = $('#ssg-body');
    if (!body) return;
    var heads = $$(':scope > h2, :scope > .ssg-faq > h2', body);
    if (heads.length < 2) {
      $$('.ssg-toc-wrap, .ssg-tocm').forEach(function (n) { n.hidden = true; });
      return;
    }
    var numbered = body.classList.contains('ssg-body--setup') || body.classList.contains('ssg-body--howto');
    var used = {}, toc = $('#ssg-toc'), tocm = $('#ssg-tocm'), links = [], step = 0;
    heads.forEach(function (h) {
      if (!h.id) {
        var id = slug(h.textContent), k = id, i = 2;
        while (used[k] || document.getElementById(k)) { k = id + '-' + i++; }
        h.id = k;
      }
      used[h.id] = 1;
      var isStep = numbered && h.parentNode === body && !h.classList.contains('ssg-nonum');
      if (isStep) step++;
      var label = h.textContent.trim();
      if (toc) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id;
        var n = document.createElement('span'); n.className = 'n'; n.textContent = isStep ? String(step) : '•';
        var t = document.createElement('span'); t.textContent = label;
        a.appendChild(n); a.appendChild(t); li.appendChild(a); toc.appendChild(li); links.push(a);
      }
      if (tocm) {
        var li2 = document.createElement('li'), a2 = document.createElement('a');
        a2.href = '#' + h.id; a2.textContent = label; li2.appendChild(a2); tocm.appendChild(li2);
      }
    });
    var ticking = false, aside = $('.ssg-aside');
    function update() {
      ticking = false;
      var ho = headerOffset();
      if (aside) aside.style.setProperty('--ssg-top', (ho + 24) + 'px');
      var line = ho + 140, act = 0;
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= line) act = i; });
      links.forEach(function (a, i) { a.classList.toggle('is-on', i === act); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* move the "You'll need" box into the sidebar on wide screens */
  function initNeed() {
    var need = $('#ssg-body .ssg-need'), slot = $('#ssg-need-slot');
    if (!need || !slot) return;
    var home = document.createComment('ssg-need');
    need.parentNode.insertBefore(home, need);
    var mq = window.matchMedia('(min-width: 990px)');
    function place() {
      if (mq.matches) slot.appendChild(need);
      else home.parentNode.insertBefore(need, home.nextSibling);
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else mq.addListener(place);
  }

  /* in-page links: offset for the sticky header, open target <details> */
  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (!el || !el.closest('.ssg')) return;
      e.preventDefault();
      if (el.tagName === 'DETAILS') el.open = true;
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
      var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
      if (history.replaceState) history.replaceState(null, '', '#' + el.id);
      var tm = a.closest('.ssg-tocm'); if (tm) tm.open = false;
    });
    if (location.hash) {
      var t = document.getElementById(decodeURIComponent(location.hash.slice(1)));
      if (t && t.tagName === 'DETAILS') t.open = true;
    }
  }

  /* lazy YouTube: <div class="ssg-video" data-yt="ID"><a href="https://www.youtube.com/watch?v=ID">Title</a></div> */
  function initVideos() {
    var cfg = window.SSG || {};
    $$('.ssg-video[data-yt]').forEach(function (box) {
      var id = (box.getAttribute('data-yt') || '').replace(/[^\w-]/g, '');
      var a = box.querySelector('a');
      if (!id || !a) return;
      var title = a.textContent.trim();
      a.textContent = '';
      var img = document.createElement('img');
      img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
      img.alt = ''; img.loading = 'lazy'; img.width = 480; img.height = 360;
      var play = document.createElement('span'); play.className = 'ssg-video__play';
      play.appendChild(document.createElement('i'));
      a.appendChild(img); a.appendChild(play);
      a.setAttribute('aria-label', (cfg.play || 'Play video') + ': ' + title);
      box.classList.add('is-ready');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&modestbranding=1';
        f.title = title; f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        f.setAttribute('allowfullscreen', '');
        box.innerHTML = ''; box.appendChild(f);
        track('guide_video_play', { video_id: id });
      });
    });
  }

  /* feedback buttons */
  function initFeedback() {
    var fb = $('.ssg-fb');
    if (!fb) return;
    fb.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-v]');
      if (!b) return;
      $$('button', fb).forEach(function (x) { x.classList.toggle('is-on', x === b); x.disabled = true; });
      var lab = $('.ssg-fb__q', fb); if (lab && fb.dataset.thanks) lab.textContent = fb.dataset.thanks;
      track('guide_feedback', { helpful: b.dataset.v, guide: fb.dataset.guide || location.pathname });
    });
  }

  /* mobile product bar: show after the header area scrolls away */
  function initBar() {
    var bar = $('.ssg-mbar'), head = $('.ssg-ahead');
    if (!bar || !head || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { bar.classList.toggle('is-on', !en[0].isIntersecting); }).observe(head);
  }

  /* listing: client-side type chips */
  function initChips() {
    var chips = $('.ssg-chips[data-filter]');
    if (!chips) return;
    var cards = $$('.ssg-grid .ssg-card[data-type]');
    chips.addEventListener('click', function (e) {
      var c = e.target.closest('.ssg-chip[data-f]');
      if (!c) return;
      var f = c.dataset.f;
      $$('.ssg-chip', chips).forEach(function (x) { x.classList.toggle('is-on', x === c); x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
      cards.forEach(function (k) { k.hidden = f !== 'all' && k.dataset.type !== f; });
    });
  }

  /* hub: instant search over the embedded index */
  function initSearch() {
    var box = $('.ssg-search'), dataEl = $('#ssg-index');
    if (!box || !dataEl) return;
    var idx;
    try { idx = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var input = $('input', box), list = $('.ssg-results', box), form = $('form', box), act = -1;
    var norm = function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
    idx.forEach(function (g) { g._h = norm(g.t + ' ' + (g.k || '') + ' ' + (g.m || '')); });
    function render() {
      var q = norm(input.value).trim(), terms = q.split(/\s+/).filter(Boolean);
      list.innerHTML = ''; act = -1;
      if (!terms.length) { list.hidden = true; return; }
      var hits = idx.filter(function (g) { return terms.every(function (t) { return g._h.indexOf(t) > -1; }); }).slice(0, 8);
      if (!hits.length) {
        var li = document.createElement('li'); li.className = 'ssg-results__empty'; li.textContent = box.dataset.empty || '';
        list.appendChild(li);
      }
      hits.forEach(function (g) {
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = g.u;
        var b = document.createElement('span'); b.textContent = g.t;
        var s = document.createElement('small'); s.textContent = [g.y, g.m].filter(Boolean).join(' · ');
        a.appendChild(b); a.appendChild(s); li.appendChild(a); list.appendChild(li);
      });
      list.hidden = false;
    }
    function move(d) {
      var as = $$('a', list); if (!as.length) return;
      act = (act + d + as.length) % as.length;
      as.forEach(function (a, i) { a.classList.toggle('is-active', i === act); });
    }
    var tmr;
    input.addEventListener('input', function () { clearTimeout(tmr); tmr = setTimeout(render, 80); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { list.hidden = true; }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      render();
      var as = $$('a', list), pick = as[act] || as[0];
      if (pick) { track('guide_search', { search_term: input.value }); location.href = pick.href; }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) list.hidden = true; });
  }

  function init() {
    initToc(); initNeed(); initAnchors(); initVideos(); initFeedback(); initBar(); initChips(); initSearch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
